import { render, staticRenderFns } from "./TeamEventCreate.vue?vue&type=template&id=3f3373ba&"
import script from "./TeamEventCreate.vue?vue&type=script&lang=ts&"
export * from "./TeamEventCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports